<template>
  <div class="bto-sb-empty-state">
      <div class="bto-sb-empty-icon">
          <span class="bto-sb-sports-icon" :class="iconClass"></span>
          <span v-if="!hideShadow" class="bto-sb-empty-icon-shadow"></span>
      </div>
      <div class="bto-sb-empty-message">
        {{message}}
        <span v-if="subMessage">{{subMessage}}</span>
      </div>
  </div>
</template>
<script>
  export default {
    name: 'EmptyState',
    props: {
      iconClass: {
        type: String,
        required: true,
      },
      message: {
        type: String,
        required: true,
      },
      subMessage: {
        type: String,
        default: '',
      },
      hideShadow: {
        type: Boolean,
        default: false,
      },
    }
  };
</script>